<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong *ngIf="environmentSettings.LAWS">Laws & Regulations</strong>
      <strong *ngIf="!environmentSettings.LAWS"> Laws & Regulations </strong>
    </span>

    <span class="header-actions">
      <button (click)="refreshComponent()" class="btn-sm btn btn-primary btn-refresh" type="button">
        <i class="fa fa-refresh"></i>Refresh</button>
    </span>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive" style="padding-left:100px;">
            <tree-root #tree [nodes]="nodes" [options]="options" [focused]="true">
              <ng-template #treeNodeTemplate let-node let-index="index">
                <span *ngIf="node.data.file==null"
                  [ngClass]="{'alignleftbold':(node.data.children && node.data.children.length!=0),'alignleft': (node.data.children && node.data.children.length==0) || !node.data.children}">{{
                  node.data.name }}</span>
                <span *ngIf="node.data.file!=null"
                  [ngClass]="{'alignleftbold':(node.data.children && node.data.children.length!=0),'alignleft': (node.data.children && node.data.children.length==0) || !node.data.children}">
                  <a href="" (click)="openInNewTab(node.data.file,node.data.name);" data-toggle="modal"
                    data-target="#myModal">
                    {{ node.data.name }}
                    <i class="fa fa-eye"></i></a>
                </span>
              </ng-template>
            </tree-root>
          </div>
          <!-- Modal -->
          <div *ngIf="iframeURL" class="modal fade" id="myModal" tabindex="-1" role="dialog"
            aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog" style="max-width:1090px;">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="myModalLabelcompliance">
                    <i class="fa fa-plus"></i>{{title}}
                  </h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="modal-body" style="padding: 0px">
                  <div style="text-align: center;">
                    <iframe [src]="iframeURL" style="width:100%; height:500px;" frameborder="0"></iframe>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade modal-size-medium" id="complinaceDialog" tabindex="-1" role="dialog" aria-labelledby=""
            aria-hidden="true">
            <div class="modal-dialog" role="document">
              <form [formGroup]="complianceAddForm" class="well">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelcompliance">
                      <i class="fa fa-plus"></i>{{compliancetitle}}
                    </h5>
                    <button (click)="dismiss()" aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>
</section>